import {Component, inject, Input, OnInit, Output, EventEmitter} from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {TimeAgoPipe} from "@shared/pipes/time-ago.pipe";
import {
  NotificationPollingService
} from "@modules/backoffice/notification-context/notification/service/notification-polling.service";
import {Notification} from "@modules/backoffice/notification-context/notification/model/notification.model";


@Component({
  standalone: true,
  selector: 'app-notification-view-modal',
  templateUrl: './notification-view-modal.component.html',
  styleUrls: ['./notification-view-modal.component.scss'],
  imports: [
    CommonModule,
    DatePipe,
    TimeAgoPipe,
  ]
})
export class NotificationViewModalComponent implements OnInit {
  @Input() notification!: Notification;
  @Input() currLang: string = 'fr';
  @Output() remove = new EventEmitter<Notification>();

  showConfirmDialog: boolean = false;
  message: string = '';

  private notificationPollingService = inject(NotificationPollingService);

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    if (!this.notification) {
      console.error('Notification object is not provided to the modal.');
      this.message = 'Error: Notification data is missing.';
      setTimeout(() => this.activeModal.close('No notification data'), 2000);
    }
  }

  closeModal(): void {
    this.activeModal.close('Close click');
  }

  removeNotification(): void {
    this.message = '';
    this.showConfirmDialog = true;
  }

  confirmDelete(): void {
    this.showConfirmDialog = false;

    console.log('Attempting to delete notification with ID:', this.notification.id);
    if (!this.notification.id) {
      console.error('Notification ID is missing or invalid!');
      this.message = 'Cannot delete: Notification ID is missing.';
      return;
    }

    this.notificationPollingService.delete(this.notification.id).subscribe({
      next: () => {
        console.log('Notification deleted successfully via service.');
        this.remove.emit(this.notification);
        this.activeModal.close('Notification removed');
      },
      error: (err: any) => {
        console.error('Error deleting notification:', err);
        this.message = 'Failed to delete notification. Please try again.';
      }
    });
  }

  cancelDelete(): void {
    this.showConfirmDialog = false;
    this.message = 'Deletion cancelled.';
  }
}
